import {
    CloseIcon,
    FiltersIcon
  } from "components/icons/index";

const TopHeader = ({
    setShowMobileFilter,
    showFilters,
    showMobileFilter,
    setShowFilter
}) => {
    return (
        <div className="flex flex-row justify-between bg-yellowgray p-3" >
            <h2 className="flex items-center justify-center text-pgray font-regular">
                {showMobileFilter &&
                    <CloseIcon onClick={() => setShowMobileFilter(!showMobileFilter)} />
                }
                <span className="font-semibold ml-0.5 text-white">Filters</span>
            </h2>

            <div>
                <FiltersIcon onClick={() => window.location.reload()} />
            </div>
        </div>
    )
}

export default TopHeader;
